import { useEffect, useRef, useState } from "react";
import { Link } from "react-router";
import { Avatar } from "./Avatar";
import styles from "./ProfileMenu.module.css";

type ProfileMenuProps = {
  userName?: string | null;
  userAvatar?: string | null;
  onSignOut?: () => void;
};

export const ProfileMenu = ({ userName, userAvatar, onSignOut }: ProfileMenuProps) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const label = userName ?? "Account";

  return (
    <div className={styles.wrap} ref={ref}>
      <button
        type="button"
        className={styles.trigger}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Account menu"
        onClick={() => setOpen((o) => !o)}
      >
        <Avatar name={label} src={userAvatar ?? undefined} />
      </button>
      {open && (
        <div className={styles.menu} role="menu">
          <Link to="/stores" role="menuitem" className={styles.item} onClick={() => setOpen(false)}>
            Stores
          </Link>
          <Link
            to="/account"
            role="menuitem"
            className={styles.item}
            onClick={() => setOpen(false)}
          >
            Account
          </Link>
          <Link
            to="/shopping"
            role="menuitem"
            className={styles.item}
            onClick={() => setOpen(false)}
          >
            Shopping
          </Link>
          {onSignOut && (
            <button
              type="button"
              role="menuitem"
              className={styles.item}
              onClick={() => {
                setOpen(false);
                onSignOut();
              }}
            >
              Sign out
            </button>
          )}
        </div>
      )}
    </div>
  );
};
